import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { Modal, Button, Row, Col, Icon } from 'antd';
import { openInquiriesText } from './DiscoverRateUtils';
import { FetchedInquiries, SearchParams } from './TypesInDiscoverRates/SearchResult';
import { InquiryConfirmationModalStyles } from './InquiryConfirmationModal.styles';
import { prettifyString } from 'src/utils/utils';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAllDataSetFilter } from 'src/actions/discoverRatesActions';

interface InquiryConfirmationModalProps extends
  StylesProps<ReturnType<typeof InquiryConfirmationModalStyles>> {
  isVisible: boolean;
  onConfirmationClose: () => void;
  inquiryData: FetchedInquiries [];
  searchParams: SearchParams;
  getAllDataSetFilter: (val, apiCall? : boolean) => void;
  onOk: () => void;
}

const InquiryConfirmationModal = (props: InquiryConfirmationModalProps): React.ReactElement => {

  const {
    isVisible,
    onConfirmationClose,
    classes,
    inquiryData,
    searchParams,
    getAllDataSetFilter,
    onOk,
  } = props;

  const renderPort = (type) => {
    return (
      <React.Fragment>
        <img style={{ maxWidth: '16px', marginRight: '6px' }}
          src={searchParams[type]?.flagS3Link} />
        {searchParams[type]?.code}
      </React.Fragment>
    );
  };

  const renderLine = (): React.ReactElement => {
    return <div className={classes.line}/>;
  };

  const renderDot = (styles): React.ReactElement => {
    return <div className={classes.dot} style={{ ...styles }} />;
  };

  const renderLineAndDots = (): React.ReactElement => {
    return (
      <span className={classes.lineAndDot}>
        {renderDot({ backgroundColor: '#999999' })}
        {renderLine()}
        {renderDot('')}
      </span>
    );
  };

  const renderContainerDetails = () => {
    const { type, size, volume, weight } = searchParams.container;
    if (volume && weight){
      return (
        <Col span={9} style={{ textAlign: 'center' }}>
          <span>Volume: {volume.value} <span className={classes.product}>{volume.unit}</span>&nbsp;&nbsp;</span>
          <span>Weight: {weight.value} <span className={classes.product}>{weight.unit}</span></span>
        </Col>
      )
    }
    return (
      <Col span={6} style={{ textAlign: 'center' }}><span>{prettifyString(type)} {size}</span></Col>
    );
  };

  const renderCargoDetails = () => {
    const { cargo, product } = searchParams.cargoDetails;
    return (
      <React.Fragment>
        <span>{prettifyString(cargo)}</span>
        <span className={classes.product}>&nbsp;{product}</span>
      </React.Fragment>
    );
  };

  const renderSearchInfo = () : React.ReactElement => {
    return (
      <Row className={classes.searchInfo}>
        <Col span={3} className={classes.port}>{renderPort('pol')}</Col>
        <Col span={2} style={{ padding: '0px 6px' }}>{renderLineAndDots()}</Col>
        <Col span={3}>{renderPort('pod')}</Col>
        {searchParams.container && renderContainerDetails()}
        <Col span={9} className={classes.cargoDetails}>{renderCargoDetails()}</Col>
      </Row>
    );
  };

  const renderDeadline = (data) : React.ReactElement => {
    return (
      <React.Fragment>
        <Icon type="hourglass" />
        <span className={classes.deadline}>
          {`${moment(data.deadline)?.format('DD MMMM YYYY | HH:mm')} Hrs`}
        </span>
      </React.Fragment>
    );
  };

  const renderInquiryCard = (data) : React.ReactElement => {
    return (
      <Row className={classes.inquiryCard}>
        <Col span={5} className={classes.inquiryNo}>{data.referenceNumber}</Col>
        <Col span={8} className={classes.cardBorder}>{renderDeadline(data)}</Col>
        <Col span={5} className={classes.cardBorder}>
          <span className={classes.labelColor}>Total Bid(s)</span>
          <span className={classes.responseCount}>{data.totalBids}</span>
        </Col>
        <Col span={6} style={{ textAlign: 'center' }}>
          <span className={classes.labelColor}>FF(s) Reponded</span>
          <span className={classes.responseCount}>{data.ffsRespondedCount}</span>
        </Col>
      </Row>
    );
  };

  const renderInquiryData = () : React.ReactElement => {
    return (
      <div style={{ margin: '12px 0px'}}>
        {inquiryData?.map(data => renderInquiryCard(data))}
      </div>
    );
  };

  return (
    <Modal
      visible={isVisible}
      zIndex={1000}
      className={classes.modal}
      title="Inquiry Confirmation"
      closable={false}
      onCancel={onConfirmationClose}
      footer={
        <React.Fragment>
          <span className={classes.cancelButton}
            onClick={() => onConfirmationClose()}>Cancel</span>
          <Button className={classes.createNewButton}
            onClick={onOk}>Create New</Button>
        </React.Fragment>
      }
    >
      <span style={{ fontWeight: 600 }}>{openInquiriesText(inquiryData?.length)}</span>
      {renderSearchInfo()}
      {renderInquiryData()}
    </Modal>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({
    getAllDataSetFilter,
  }, dispatch);
};

export default connect(null,
  mapDispatchToProps)(withStyles(InquiryConfirmationModalStyles)(InquiryConfirmationModal));
